import { questionsChomage, questionValidationRules } from "features/subscription-process/slices/thunks/mockChomageQuestions"

export const UnemploymentRisk = () => {
  const questions = questionValidationRules.map(rule => {
    const question = questionsChomage
      .flatMap(group => group.questions)
      .find(q => q.key === rule.key);
    return {
      label: question?.label || "",
      expectedValue: rule.expectedValue,
      possibleAnswers: question?.possibleAnswers || [true, false]
    };
  });

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden">
      <div className="bg-gradient-to-r from-primary/10 to-primary/5 px-6 py-4 border-b border-primary/20">
        <h3 className="text-lg font-semibold text-primary">Évaluation du risque de chômage</h3>
      </div>

      <div className="p-6 space-y-4">
        {questions.map((question, questionIndex) => (
          <div
            key={questionIndex}
            className={`
              relative p-5 rounded-lg border-l-4 transition-all duration-200 hover:shadow-md
              ${question.expectedValue
                ? 'bg-primary/5 border-l-primary/60 hover:bg-primary/10'
                : 'bg-gray-50/80 border-l-gray-400/60 hover:bg-gray-100/80'
              }
            `}
          >
            <div className="flex items-start justify-between gap-4">
              {/* Question */}
              <div className="flex-1">
                <label className="block font-medium text-gray-800 mb-3 leading-relaxed">
                  {question.label}
                </label>

                {/* Réponse avec indicateur visuel */}
                <div className="flex items-center gap-3">
                  <div className={`
                    inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium
                    ${question.expectedValue
                      ? 'bg-primary/20 text-primary-dark border border-primary/30'
                      : 'bg-gray-200/80 text-gray-700 border border-gray-300/50'
                    }
                  `}>
                    <span className={`
                      w-2 h-2 rounded-full mr-2
                      ${question.expectedValue ? 'bg-primary' : 'bg-gray-500'}
                    `}></span>
                    {question.expectedValue === true ? "Oui" : "Non"}
                  </div>
                </div>
              </div>

              {/* Icône d'état */}
              <div className={`
                w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0
                ${question.expectedValue
                  ? 'bg-primary/15 text-primary'
                  : 'bg-gray-200/60 text-gray-500'
                }
              `}>
                {question.expectedValue ? (
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                ) : (
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Footer informatif */}
      <div className="bg-gray-50/50 px-6 py-4 border-t border-gray-200/50">
        <p className="text-sm text-gray-600 flex items-center gap-2">
          <svg className="w-4 h-4 text-primary/60" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
          </svg>
          Réponses attendues pour l'évaluation du profil de risque
        </p>
      </div>
    </div>
  )
}
